import z from 'zod';
import { defineOrgQuery } from '../shared/procedures';

export const blockQueries = {
  blocksForTracks: defineOrgQuery(
    z.object({ trackIds: z.array(z.string()) }),
    ({ args: { trackIds }, orgQuery }) =>
      orgQuery('Block').where('trackId', 'IN', trackIds),
  ),
};
